import { useSEO } from '@/hooks/useSEO';

export default function Disclaimer() {
  useSEO(
    'Disclaimer | Earning Calculators.Com',
    'Read the disclaimer for Earning Calculators.Com financial calculators.'
  );

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-headline text-4xl md-text-5xl font-bold tracking-tighter mb-6 text-center">
          Disclaimer
        </h1>
        <div className="prose prose-lg mx-auto text-muted-foreground">
          <p>
            The information and calculations provided on Earning Calculators.Com are for general informational and educational purposes only. All calculators are provided as tools to help you estimate potential earnings and expenses, and are not a promise or guarantee of income.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Not Financial Advice</h2>
          <p>
            The content on this website is not intended to be a substitute for professional financial advice. Always seek the advice of a qualified financial advisor, accountant, or other qualified professional with any questions you may have regarding your personal financial situation. Never disregard professional advice or delay in seeking it because of something you have read on this website.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Accuracy of Information</h2>
          <p>
            While we strive to keep the information and calculation formulas up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.
          </p>
          <p>
            Fee structures, royalty rates, and platform policies change frequently. The default values in our calculators are based on publicly available information at the time of their creation but may not reflect the most current rates. You are responsible for verifying all rates and fees with the respective platforms.
          </p>
        </div>
      </div>
    </div>
  );
}